<div>
  <span>{{ this.value }}</span>
</div>
